import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";

import reportWebVitals from "@src/reportWebVitals";
import { Paths } from "@utils/const";

const LoadingPage = lazy(() => import("@components/loadingPage"));
const Layout = lazy(() => import("@pages/layout"));
const DashboardScreen = lazy(() => import("@pages/dashboard"));
const LoginScreen = lazy(() => import("@pages/login"));
const HomeScreen = lazy(() => import("@pages/home"));
const EntourageScreen = lazy(() => import("@pages/entourage"));
const AttireScreen = lazy(() => import("@pages/attire"));
const ScheduleScreen = lazy(() => import("@pages/schedule"));
const TravelScreen = lazy(() => import("@pages/travel"));
const GalleryScreen = lazy(() => import("@pages/gallery"));
const FAQScreen = lazy(() => import("@pages/faq"));
const RsvpScreen = lazy(() => import("@pages/rsvp"));
const OurStoryScreen = lazy(() => import("@pages/our-story"));
const ThingsToDoScreen = lazy(() => import("@pages/things-to-do"));
const MochiScreen = lazy(() => import("@pages/mochi"));
const NotFoundScreen = lazy(() => import("@pages/not-found"));

import "@src/index.css";

const router = createBrowserRouter([
  {
    path: Paths.Home,
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomeScreen />,
      },
      {
        path: Paths.Entourage,
        element: <EntourageScreen />,
      },
      {
        path: Paths.Attire,
        element: <AttireScreen />,
      },

      {
        path: Paths.Schedule,
        element: <ScheduleScreen />,
      },

      {
        path: Paths.Travel,
        element: <TravelScreen />,
      },
      {
        path: Paths.Gallery,
        element: <GalleryScreen />,
      },
      {
        path: Paths.Faq,
        element: <FAQScreen />,
      },
      {
        path: Paths.Rsvp,
        element: <RsvpScreen />,
      },
      {
        path: Paths.Story,
        element: <OurStoryScreen />,
      },
      {
        path: Paths.Mochi,
        element: <MochiScreen />,
      },
      {
        path: Paths.ToDo,
        element: <ThingsToDoScreen />,
      },
      {
        path: "/admin",
        children: [
          {
            path: "login",
            element: <LoginScreen />,
          },
          {
            path: "dashboard",
            element: <DashboardScreen />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFoundScreen />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Suspense fallback={<LoadingPage />}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();

if ("serviceWorker" in navigator) {
  registerSW();
}
